import * as $ from 'jquery';
import { connect, useDispatch } from 'react-redux';
import { quickActionsReset } from '../../../redux/actions/dashboard/quickActionActions';
import { useEffect, useState } from 'react';
import Alert from '../../../itrust_common/components/Alert';
import { reportCreate, reportEdit, reportReset } from '../../../redux/actions/reports/reportsActions';
import { examTemplatesLoad } from '../../../itrust_common/redux/actions/settingActions/examTemplateActions';

function SelectPrescriptionProvider(props) {
  const { providers, prescriptionEditing, default_provider_id } = props
  const [arbitraryProvider, setArbitraryProvider] = useState('')
  const [selectedProviderId, setSelectedProviderId] = useState(default_provider_id || '')
  const [activeType, setActiveType] = useState('provider')
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      handleResetData()
    }
  }, [])

  const handleResetData = () => {
    dispatch(reportReset())
    dispatch(quickActionsReset())
    setSelectedProviderId(null)
    setArbitraryProvider('')
  }

  const handleCancel = () => {
    $('#selectPrescriptionProvider-modal').modal('hide');
    handleResetData()
  }

  const handleNextStep = async () => {
    if (activeType == 'arbitrary' && !arbitraryProvider) {
      Alert.warning('Please add Anonymous Provider Name.')
      return false
    }
    if (activeType !== 'arbitrary' && !selectedProviderId) {
      Alert.warning('Please select provider.')
      return false
    }
    $('#selectPrescriptionProvider-modal').modal('hide');
    let data = arbitraryProvider ? { staff_name: arbitraryProvider } : { staff_id: selectedProviderId }
    data = { ...data, store_id: localStorage.getItem('StoreID') }
    const createData = {
      finalized_lenses_attributes: [], finalized_glasses_attributes: [], patient_id: prescriptionEditing?.patient_id, other_details: data, report_type: "quick_action", category: 'prescription', store_id: localStorage.getItem('StoreID')
    }
    await dispatch(reportCreate(createData, { include: '*' }))
    dispatch(reportEdit({ other_details: data }))
    await dispatch(examTemplatesLoad({
      sort: 'settings_exam_templates.position',
      direction: 'asc',
      rpp: 9999,
      filter: activeType === 'arbitrary'
        ? { master_list: true }
        : { staff_id: selectedProviderId },
      exam_listing: true,
    }))
    $('#prescription-modal').modal('show');
    dispatch(reportEdit({ showPrescriptionModal: true }))
  }

  const handleSelectProvider = (providerId) => {
    setSelectedProviderId(providerId)
  }

  return (
    <div className="appointment-modal">
      <div className="modal book-appointment popperAppointment w-0 h-0 position-fixed" id="selectPrescriptionProvider-modal" data-backdrop="static">
        <div className="modal-dialog">
          <div className="modal-content border-0 shadow">
            <div className="modal-header p-5 align-items-center">
              <h6>Select Prescription Provider</h6>
              <div>
                <button type="button" className="btn btn-outline-primary mr-4" onClick={handleCancel}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleNextStep}>Next</button>
              </div>
            </div>
            <div className='px-6 py-7'>
              <div className='row mb-5'>
                <div className='col-6 pr-2'>
                  <div className={`bg-light pl-3 pr-5 py-5 mb-3 border border-1 rounded d-flex justify-content-between align-items-center ${activeType == 'provider' && 'border-primary'}`}>
                    <div className='d-flex align-items-center '>
                      <input type="radio" className='visibility-hidden' name="prescriptionProviderType" id="prescriptionProviderType1" value="provider" checked={activeType == 'provider'} onChange={() => setActiveType('provider')} style={{ width: 0 }} />
                      <i className={`las la-shield-alt mr-2 font-size-30 ${activeType == 'provider' && 'text-primary'}`}></i>
                      <label className='mb-0 ' htmlFor="prescriptionProviderType1">
                        <h5 className={`font-size-20 ${activeType == 'provider' && 'text-primary'}`}>iTRUST Provider</h5>
                      </label>
                    </div>
                    {activeType == 'provider' && <i className="las la-check-circle text-primary font-size-24"></i>}
                  </div>
                </div>
                <div className='col-6 pl-2'>
                  <div className={`bg-light pl-3 pr-5 py-5 mb-3 border border-1 rounded d-flex justify-content-between align-items-center ${activeType == 'arbitrary' && 'border-primary'}`}>
                    <div className='d-flex align-items-center '>
                      <input type="radio" className='visibility-hidden' name="prescriptionProviderType" id="prescriptionProviderType2" value="arbitrary" checked={activeType == 'arbitrary'} onChange={() => setActiveType('arbitrary')} style={{ width: 0 }} />
                      <i className={`las la-user-alt mr-2 font-size-30 ${activeType == 'arbitrary' && 'text-primary'}`}></i>
                      <label className='mb-0 ' htmlFor="prescriptionProviderType2">
                        <h5 className={`text-nowrap font-size-20 ${activeType == 'arbitrary' && 'text-primary'}`}>Anonymous Provider</h5>
                      </label>
                    </div>
                    {activeType == 'arbitrary' && <i className="las la-check-circle text-primary font-size-24"></i>}
                  </div>
                </div>
              </div>
              {activeType == 'provider' ? <div className="form-group mb-0">
                <label htmlFor="prescriptionProvider">Select Provider</label>
                <select className="form-control" id="prescriptionProvider" value={selectedProviderId} onChange={(e) => handleSelectProvider(e.target.value)} disabled={arbitraryProvider}>
                  <option value="">Select Provider</option>
                  {providers.map((item) => <option value={item.id}>{item.name}</option>)}
                </select>
              </div> :
                <div>
                  <label>Anonymous Provider</label>
                  <input type="text" className='form-control font-control-sm' onChange={(e) => setArbitraryProvider(e.target.value)} />
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { currentStore, reports: { editing } } = state
  return {
    providers: currentStore.staffs,
    default_provider_id: currentStore.store?.default_provider_id,
    prescriptionEditing: editing
  }
}

export default connect(mapStateToProps)(SelectPrescriptionProvider);